import produce from "immer";
import { LoadState } from "../../../constants/enums";
import { IStoreState } from "../../initialStoreState";
import { defaultLifeInsuranceRidersState } from "./lifeInsuranceRiders.types";
import { LifeInsuranceRidersAction } from ".";
import {
  CLEAR_LIFE_INSURANCE_RIDERS_STATE,
  FETCH_LIFE_INSURANCE_RIDERS_FAILED,
  FETCH_LIFE_INSURANCE_RIDERS_PROGRESS,
  FETCH_LIFE_INSURANCE_RIDERS_SUCCESS,
} from "./lifeInsuranceRidersActions";

export const lifeInsuranceRidersReducer = (
  state: IStoreState["lifeInsurance"]["riders"] = defaultLifeInsuranceRidersState,
  action: LifeInsuranceRidersAction
) => {
  switch (action.type) {
    case FETCH_LIFE_INSURANCE_RIDERS_PROGRESS: {
      const newState = produce(state, (draftState: any) => {
        draftState.loading = LoadState.InProgress;
        draftState.data = defaultLifeInsuranceRidersState["data"];
      });
      return newState;
    }
    case FETCH_LIFE_INSURANCE_RIDERS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState: any) => {
        draftState.loading = LoadState.Loaded;
        draftState.data = data;
      });
      return newState;
    }
    case FETCH_LIFE_INSURANCE_RIDERS_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState: any) => {
        draftState.loading = LoadState.Failed;
        draftState.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_LIFE_INSURANCE_RIDERS_STATE: {
      return defaultLifeInsuranceRidersState;
    }
    default: {
      return state;
    }
  }
};
